import React from 'react';
import logo from './logo.svg';
import './App.css';
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Approved from './screens/Approved';
import Declined from './screens/Declined';
import MPGSSession from './screens/MPGSSession';

function App() {
  return (
    
    <Router>
      <Routes>
      <Route path='/approved' element={<Approved/>} />
      <Route path='/declined' element={<Declined/>} />
      <Route path='/MPGS/:sessionId' element={<MPGSSession />}/>
      <Route path='*' element={<Declined/>}/>
      </Routes>
    </Router>
  );
}

export default App;
